export default () => ({
  blogs: [],
  blogCount: 0,
  foundBlogs: [],
  blog: null,
  comments: [],
  comment: null,
  attachments: [],
  blogStatus: null,
  blogType: null,
  defaultBlog: {
    blog: null,
    firm: null,
    blogName: null,
    blogType: null,
    blogStatus: null,
    createdBy: null,
    content: null,
    imageUrl: null,
    blogTags: null,
    scheduledOn: null,
    isSticky: false,
    sort: 0,
    isAllowComments: false,
    isIncludeShop: false,
    attachments: []
  },
  defaultComment: {
    blogComment: null,
    blog: null,
    createdBy: null,
    content: null
  },
  searchTerm: null,
  pageSize: 10,
  sortBy: 'desc',
  orderBy: 'createdBy'
})



// WEBPACK FOOTER //
// ./src/store/modules/blog/state.js